(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3ScoreHistory', {
            templateUrl: 'app/shared/score-history/score-history.component.html',
            controller: ScoreHistoryComponent,
            bindings: { history: '<' }
        });

    var isUndefined = angular.isUndefined,
        noop = angular.noop;

    ScoreHistoryComponent.$inject = ['$scope', '$state', 'user', 'Score', 'alert', 'confirm', 'scoreHistoryPageSize', 'scoring_resources', 'scoreLegendModal', 'scoreTypeLegendModal', 'signInManager', 'scoreAdjustmentModal', 'scoreDifferentialModal', 'diffLegendModal'];
    function ScoreHistoryComponent($scope, $state, user, Score, alert, confirm, scoreHistoryPageSize, resources, scoreLegendModal, scoreTypeLegendModal, signInManager, scoreAdjustmentModal, scoreDifferentialModal, diffLegendModal) {
        var ctrl = this;

        // Properties
        ctrl.page = 1;
        ctrl.pageSize = scoreHistoryPageSize;
        Object.defineProperty(ctrl, 'pageCount', { get: getPageCount });
        Object.defineProperty(ctrl, 'dateFormat', { get: getDateFormat });
        Object.defineProperty(ctrl, 'isAdminPage', { get: getIsAdminPage });
        ctrl.isNationalLookupAdmin = user.isNationalLookupAdmin;

        // Methods
        ctrl.previous = seek.bind(ctrl, -1);
        ctrl.next = seek.bind(ctrl, 1);
        ctrl.showScoreLegend = showScoreLegend;
        ctrl.showDiffLegend = showDiffLegend;
        ctrl.showScoreAdjustment = showScoreAdjustment;
        ctrl.showScoreDifferential = showScoreDifferential;
        ctrl.showScoreTypeLegend = showScoreTypeLegend;
        ctrl.editScore = editScore;
        ctrl.deleteScore = deleteScore;

        ////////////////////////////////////////////////////
        function seek(offset, origin) {
            var page = origin === 'begin' ? 1 : origin === 'end' ? ctrl.pageCount : ctrl.page,
                newPage = Math.max(page + offset, 1),
                pageSize = ctrl.pageSize,
                individualId = ctrl.history.individualId;

            Score.getHistory({ individualId: individualId, $skip: (newPage - 1) * pageSize, $top: pageSize }, success, error, true);

            function success(history) {
                var pageCount = getPageCount(history.total, pageSize),
                    isPastTheEnd = !history.data.length && pageCount;

                if (isPastTheEnd)
                    return seek(0, 'end');
                ctrl.history = history;
                ctrl.page = newPage;
                return history;
            }

            function error(rejection) {
                var isCancellation = rejection && rejection.status === -1;
                if (!isCancellation)
                    alert.error(resources.scoreHistoryRequestFailed);
                return $q.reject(rejection);
            }
        }
        function getPageCount(totalCount, pageSize) {
            totalCount = isUndefined(totalCount) ? ctrl.history.total : totalCount;
            pageSize = isUndefined(pageSize) ? ctrl.pageSize : pageSize;
            return Math.ceil(totalCount / pageSize);
        }
        function getDateFormat() {
            return ctrl.history.showComplete ? 'shortDate' : 'generalDate';
        }
        function getIsAdminPage() {
            var data = $state.$current.data;
            return data && data.requireAdmin;
        }
        function showScoreLegend() {
            scoreLegendModal().result.catch(noop);
        }
        function showDiffLegend() {
            diffLegendModal().result.catch(noop);
        }
        function showScoreAdjustment(score) {
            scoreAdjustmentModal(score).result.catch(noop);
        }
        function showScoreDifferential(score) {
            scoreDifferentialModal(score).result.catch(noop);
        }
        function showScoreTypeLegend() {
            scoreTypeLegendModal().result.catch(noop);
        }
        function deleteScore(score) {
            confirm(resources.confirmDeleteScore).then(deleteScore, noop);

            function deleteScore() {
                Score.delete({ id: score.id }, true).$promise
                    .then(removeRow)
                    .then(refreshUser)
                    .then(emitUserChanged)
                    .catch(showError);

                function removeRow() {
                    var scores = ctrl.history.data,
                        index = scores.indexOf(score);
                    if (index != -1)
                        scores.splice(index, 1);
                }

                function refreshUser() {
                    return signInManager.refresh().catch(noop);
                }

                function emitUserChanged() {
                    $scope.$emit('$userChanged');
                }
                function showError() {
                    alert.error(resources.deleteScoreFailed);
                }
            }
        }

        function editScore(score) {
            var state = (ctrl.isAdminPage ? 'member-admin.' : '') + 'post-score',
                params = { individualId: ctrl.history.individualId, scoreId: score.id };

            $state.go(state, params);
        }
    }
})();